import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechDeleteOneClient(club, idClient) {

  var url = "/reservation/delete_client/" + club + "/" + idClient;

  return FetchGetDataWithAuthNEW(url);
}

